
function getConfig(runMode) {
  console.log("getConfig for runMode = " + runMode);
  let config = {};
  switch (runMode) {
    case "prod": 
      config = {
        baseApiUrl: "https://api.floorfound.com",
        baseProductImageUrl: "https://storage.googleapis.com/floorfound-prod-cdn/products/",
        keycloakRealm: "floorfound",
        keycloakUrl: "https://auth.floorfound.com/auth/",
        keycloakClientId: "floorfound-app",
        baseFFStorefrontProductUrl: "https://floorfound.store/",
        baseProvisioningAppUrl: 'https://app.floorfound.com/',
        baseCommerceAppUrl: 'https://dashboard-floorfound.web.app/',
        basePlatformAppUrl: "https://recommerce.floorfound.com",
      };
      break;
    case "dev": 
      config = {
        baseApiUrl: "https://api-dev.floorfound.com",
        baseProductImageUrl: "https://storage.googleapis.com/floorfound-dev-cdn/products/",
        keycloakRealm: "floorfound",
        keycloakUrl: "https://auth-dev.floorfound.com/auth/",
        keycloakClientId: "floorfound-app",
        baseFFStorefrontProductUrl: "https://bc-dev.floorfound.store/",
        baseProvisioningAppUrl: 'https://app-dev.floorfound.com/',
        baseCommerceAppUrl: 'https://dashboard-floorfound-dev.web.app/',
        basePlatformAppUrl: "https://recommerce-dev.floorfound.com",
      };
      break;
    default:
      // default to local development mode
      config = {
        baseApiUrl: process.env.REACT_APP_BASE_API_URL ?? "http://localhost:9000",
        baseProductImageUrl: process.env.REACT_APP_BASE_PRODUCT_IMAGE_URL ?? "http://localhost:8000/media/products/",
        keycloakRealm: process.env.REACT_APP_KEYCLOAK_REALM ?? "floorfound",
        keycloakUrl: process.env.REACT_APP_KEYCLOAK_URL ?? "http://localhost:8080/auth/",
        keycloakClientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID ?? "floorfound-app",
        baseFFStorefrontProductUrl: process.env.REACT_APP_BASE_FF_STOREFRONT_PRODUCT_URL ?? "https://bc-dev.floorfound.store/",
        baseProvisioningAppUrl: process.env.REACT_APP_BASE_PROVISIONING_APP_URL ?? 'http://localhost:3000/',
        baseCommerceAppUrl: process.env.REACT_APP_BASE_COMMERCE_APP_URL ?? 'http://localhost:9080/',
        basePlatformAppUrl: process.env.REACT_APP_BASE_PLATFORM_APP_URL ?? 'http://localhost:4200/',
      };
      break;
  }
  return config;
}

export const appConfig = getConfig(process.env.REACT_APP_RUN_MODE);
